/**
 * Parse model-owned card metadata, ignoring incomplete or unsupported rules.
 */
export function getForcedMinimumRule(card) {
    const {
        forcedMinimumType: type,
        forcedMinimumVisitorType: visitorType,
        forcedMinimumMultiplier: rawMultiplier
    } = card.dataset;
    const multiplier = Number(rawMultiplier);
    if (type !== 'seat_visitor_type_multiplier' || !visitorType ||
        !/^\d+$/.test(rawMultiplier || '') || !Number.isSafeInteger(multiplier) || multiplier < 1 || multiplier > 4294967295) {
        return null;
    }
    return {visitorType, multiplier};
}

/**
 * Apply every valid card rule before the caller rebuilds state and refreshes totals once.
 * Mutate controls directly; emitting change events here would recursively rebuild state.
 */
export function applyForcedMinimumAddons(container) {
    const quantities = {};
    container.querySelectorAll('.seat-type-input[data-visitor-type-id]').forEach(input => {
        const quantity = Number(input.value);
        if (Number.isSafeInteger(quantity) && quantity > 0) {
            const visitor = input.dataset.visitorTypeId;
            quantities[visitor] = (quantities[visitor] || 0) + quantity;
        }
    });

    container.querySelectorAll('.addon-container[data-forced-minimum-type]').forEach(card => {
        const rule = getForcedMinimumRule(card);
        const checkbox = card.querySelector('input[type="checkbox"]');
        const count = card.querySelector('.addon-count-input');
        const controls = card.querySelector('.count-control-container');
        const subtract = card.querySelector('.subtract-button');
        if (!rule || !checkbox || !count || !controls || !subtract) {
            return;
        }

        const floor = (quantities[rule.visitorType] || 0) * rule.multiplier;
        if (!Number.isSafeInteger(floor)) {
            return;
        }
        if (floor === 0) {
            subtract.disabled = false;
            return;
        }

        checkbox.checked = true;
        card.classList.add('selected');
        controls.classList.remove('d-none');
        const current = Number(count.value);
        if (!Number.isSafeInteger(current) || current < floor) {
            count.value = String(floor);
        }
        subtract.disabled = Number(count.value) <= floor;
    });
}
